/**
 * Business Constants Configuration
 * ================================
 * Central configuration file for all business information.
 * Update these values to customize the website for your business.
 */

// ============================================
// BUSINESS INFORMATION
// ============================================
export const BUSINESS_INFO = {
  name: 'Gup Shup – Chit Chat Chai',
  shortName: 'Gup Shup',
  tagline: 'Collier Row\'s Favourite Chai Cafe & Street Food Spot',
  description: 'Experience authentic Indo-Pakistani chai and delicious street food in the heart of Collier Row, Romford. Gup Shup brings the vibrant flavours of India and Pakistan to your neighbourhood.',

  // Contact Details
  email: 'gupshupldn@gmail.com',
  phone: '01708 607796',

  // Address
  address: {
    street: '3 Clockhouse Lane',
    area: 'Collier Row',
    city: 'Romford',
    postcode: 'RM5 3PH',
    country: 'United Kingdom',
    full: '3 Clockhouse Lane, Collier Row, Romford, RM5 3PH'
  },

  // Coordinates for Google Maps
  coordinates: {
    lat: 51.5882,
    lng: 0.1536
  }
};

// ============================================
// EXTERNAL SERVICE URLS
// ============================================
export const EXTERNAL_URLS = {
  // Toast Online Ordering URL (for collection)
  ordering: 'https://order.toasttab.com/online/gup-shup-chit-chat-chai-3-clockhouse-lane',

  // Toast Tables Reservation URL
  reservation: 'https://tables.toasttab.com/restaurants/7feff01d-6c72-4095-8ba3-4f46bec8b612/reserve',

  // Toast Loyalty/Rewards Program URL
  loyalty: 'https://www.toasttab.com/gup-shup-chit-chat-chai-3-clockhouse-lane/rewardsSignup',

  // Delivery Service URLs
  deliveroo: 'https://deliveroo.co.uk/menu/london/collier-row/gup-shup-chit-chat-chai',
  uberEats: 'https://www.ubereats.com/gb/store/gup-shup-chit-chat-chai/lSedyoAfVPOh7d18Gmr8mw',
  justEat: 'https://www.just-eat.co.uk/restaurants-gup-shup-chit-chat-chai-romford/menu',

  // Google Maps Embed URL
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2479.8!2d0.1536!3d51.5882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sGup%20Shup!5e0!3m2!1sen!2suk!4v1234567890',

  // Google Maps Directions URL
  googleMapsDirections: 'https://www.google.com/maps/dir/?api=1&destination=3+Clockhouse+Lane,+Collier+Row,+Romford+RM5+3PH'
};

// ============================================
// SOCIAL MEDIA LINKS
// ============================================
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/gupshupldn/',
  facebook: 'https://www.facebook.com/gupshupldn/',
  tiktok: 'https://www.tiktok.com/discover/gupshup-romford',
  whatsapp: 'https://whatsapp.com/channel/0029VbDLKyS1XquQEwFOe53R'
};

// ============================================
// OPENING HOURS
// ============================================
export const OPENING_HOURS = {
  monday: { open: null, close: null, closed: true },
  tuesday: { open: '09:00', close: '22:00', closed: false },
  wednesday: { open: '09:00', close: '22:00', closed: false },
  thursday: { open: '09:00', close: '22:00', closed: false },
  friday: { open: '09:00', close: '22:00', closed: false },
  saturday: { open: '10:00', close: '22:00', closed: false },
  sunday: { open: '10:00', close: '22:00', closed: false },
  bankHoliday: { open: '09:00', close: '22:00', closed: false }
};

// Formatted opening hours for display
export const OPENING_HOURS_DISPLAY = [
  { day: 'Monday', hours: 'Closed' },
  { day: 'Tuesday', hours: '9:00 AM - 10:00 PM' },
  { day: 'Wednesday', hours: '9:00 AM - 10:00 PM' },
  { day: 'Thursday', hours: '9:00 AM - 10:00 PM' },
  { day: 'Friday', hours: '9:00 AM - 10:00 PM' },
  { day: 'Saturday', hours: '10:00 AM - 10:00 PM' },
  { day: 'Sunday', hours: '10:00 AM - 10:00 PM' },
  { day: 'Bank Holidays', hours: '9:00 AM - 10:00 PM' }
];

// ============================================
// BRAND COLORS
// ============================================
export const BRAND_COLORS = {
  primary: '#2D5016',      // Green
  primaryLight: '#3D6B1E', // Lighter green for hover states
  primaryDark: '#1E3A0F',  // Darker green
  accent: '#D4A017',       // Yellow
  accentLight: '#E5B82A',  // Lighter yellow for hover states
  accentDark: '#B8890F',   // Darker yellow
  white: '#FFFFFF',
  beige: '#F5F5DC',
  lightGrey: '#F3F4F6',
  grey: '#6B7280',
  darkGrey: '#374151',
  black: '#111827'
};

// ============================================
// NAVIGATION LINKS
// ============================================
export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about-us' },
  { name: 'Menu', path: '/menu' },
  { name: 'Order Online', path: '/order-online' },
  { name: 'Book Table', path: '/book-table' },
  { name: 'Rewards', path: '/rewards' },
  { name: 'Location', path: '/location' },
  { name: 'Contact', path: '/contact-us' }
];

// ============================================
// MENU PDF URL
// ============================================
export const MENU_PDF_URL = '/menu.pdf'; // Place your PDF in the public folder
